import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { NotificationService } from '../../_services/notification.service';
import { environment } from '../../../environments/environment';
import { ElasticSearchService } from '../../_services/elastic-search.service';
import { UserService } from '../../_services/user.service';
import { ReplyItemComponent } from '../reply-item/reply-item.component';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router'
import { AlertService } from '../../_services/index';

@Component({
  selector: 'app-reply',
  templateUrl: './reply.component.html',
  styleUrls: ['./reply.component.css'],
  inputs: ['post', 'user']
})
export class ReplyComponent implements OnInit {
  post;
  user;
  size: number;
  @ViewChild("commentText") commentText: ElementRef;
  @ViewChild(ReplyItemComponent) commentItem: ReplyItemComponent;
  commentScroll = 3;
  userId = localStorage.getItem('currentUserId');
  constructor(
    private elasticSearchService: ElasticSearchService,
    public modalService: NgbModal,
    private userService: UserService,
    private router: Router,
    private alertService: AlertService,
    private route: ActivatedRoute,
    public notificationService: NotificationService) {
    //this.userId = this.userService.getUid();
  }

  ngOnInit() {
  }

  commentKeyPress(event: KeyboardEvent) {
    if (event.keyCode === 13) {
      event.preventDefault();
      if (this.commentText.nativeElement.value.replace(/\s/g, '')) {
        this.postComment();
      }
    }
  }

  postComment() {
    // if (post.user.username != this.user.username) {
    //   this.getPoint(this.user, 'comment');
    // }
    this.commentText.nativeElement.value = "";
  }


  async getPoint(postUser: any, type: string) {

  }
  focus() {
    this.commentText.nativeElement.classList.add("active");
  }

  open(content, ctrl) {

    if (this.user) {
      const myPosts = Object.values(this.user.myPosts).filter(post => post['modifyDate'] > Date.now() - 86400000);

      if (myPosts.length >= 20 && ctrl == 0) {
        this.alertService.error('Gerçekçi deneyimlerini paylaşabilmemiz için günlük yorum yapma hakkın 10 ile sınırlı, seni yarın burada bekliyor olacağız.')
      } else {
        this.modalService.open(content, { backdrop: "static" });
      }
    } else {
      this.router.navigate(["/auth"]);
    }
  }

}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/post-item/reply/reply.component.ts